import DetailRelatedCourses from './DetailRelatedCourses'

export default DetailRelatedCourses
// eslint-disable-next-line import/export
export * from './DetailRelatedCourses'
